import { z } from 'zod';
export var FloorPlansSchema = z.object({
    floorPlanFile: z
        .any()
        .refine(function (file) { return file instanceof File && file.size > 0; }, 'Поле обязательно для заполнения')
        .refine(function (file) { return file.type === 'application/pdf'; }, 'Файл должен быть в формате PDF'),
    floorPlanPdf: z.string().min(1, 'Поле обязательно для заполнения'),
});
